import { useTranslation } from 'react-i18next';

// Extraído de ClientsView.jsx (02.3-client.md paso b) -- el dropdown de "quién tiene acceso a
// esta pestaña". Presentacional puro: recibe la lista ya filtrada/ordenada y el estado de admin
// ya resuelto por props, no reimplementa el criterio de "quién es admin" (eso vive en el
// container, `isAdminRole`, para no duplicar la lógica de roles en dos sitios).
export default function TabPermissionsDropdown({
  permsRef,
  allUsers,
  authorizedUsers,
  showPermsDrop,
  onToggleDrop,
  permsSearch,
  onPermsSearchChange,
  sortedPermsDropdownUsers,
  isUserAdmin,
  onTogglePerm,
}) {
  const { t } = useTranslation('client');

  return (
    <div ref={permsRef} style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <div style={{ display: 'flex', cursor: 'pointer' }} onClick={onToggleDrop}>
         {authorizedUsers.slice(0, 3).map((u, i) => (
            <div key={u.id} style={{
                width: '28px', height: '28px', borderRadius: '50%', background: '#333',
                border: '2px solid #0d0d0f', marginLeft: i > 0 ? '-8px' : '0', zIndex: 10 - i,
                display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden'
            }} title={u.nick}>
                {(u['link-profile-img-thumb'] || u['link-profile-img']) ? <img src={(u['link-profile-img-thumb'] || u['link-profile-img'])} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="" loading="lazy"/> : <span style={{fontSize:'12px', color:'#fff'}}>{(u.nick||'?')[0].toUpperCase()}</span>}
            </div>
         ))}
         {authorizedUsers.length > 3 && (
            <div style={{
                width: '28px', height: '28px', borderRadius: '50%', background: '#444',
                border: '2px solid #0d0d0f', marginLeft: '-8px', zIndex: 7,
                display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '10px'
            }}>
                +{authorizedUsers.length - 3}
            </div>
         )}
      </div>

      {showPermsDrop && (
         <div style={{
             position: 'absolute', top: '36px', right: 0, width: '220px', background: '#1a1a1a',
             border: '1px solid rgba(255,255,255,0.1)', borderRadius: 'var(--radius-md)', padding: 'var(--space-2)', zIndex: 100,
             boxShadow: '0 4px 12px rgba(0,0,0,0.5)'
         }}>
             <input
                autoFocus
                placeholder={t('permissions.searchPlaceholder')}
                aria-label={t('permissions.searchAriaLabel')}
                value={permsSearch}
                onChange={e => onPermsSearchChange(e.target.value)}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                        // Filtra `allUsers` (no la lista ya ordenada) -- mismo orden que antes,
                        // no el orden "activos primero" de `sortedPermsDropdownUsers`.
                        const matches = allUsers.filter(u => (u.nick||'').toLowerCase().includes(permsSearch.toLowerCase()));
                        if (matches.length > 0) {
                            const u = matches[0];
                            if (!isUserAdmin(u)) onTogglePerm(u.id);
                        }
                    }
                }}
                style={{ width: '100%', background: '#0d0d0f', color: '#fff', border: '1px solid rgba(255,255,255,0.2)', padding: 'var(--space-2)', borderRadius: 'var(--radius-sm)', fontSize: '12px', marginBottom: 'var(--space-2)', outline:'none' }}
             />
             <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {sortedPermsDropdownUsers.map(u => {
                    const isAct = authorizedUsers.some(au => au.id === u.id);
                    const isAdmin = isUserAdmin(u);
                    return (
                        <div key={u.id} style={{ display: 'flex', alignItems: 'center', padding: 'var(--space-2) var(--space-1)', gap: 'var(--space-2)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                            <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#333', overflow: 'hidden' }}>
                                {(u['link-profile-img-thumb'] || u['link-profile-img']) ? <img src={(u['link-profile-img-thumb'] || u['link-profile-img'])} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="" loading="lazy"/> : <div style={{width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'10px',color:'#fff'}}>{(u.nick||'?')[0].toUpperCase()}</div>}
                            </div>
                            <div style={{ flex: 1, fontSize: '12px', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{u.nick}</div>
                            {isAdmin ? (
                                <div style={{ fontSize: '10px', color: '#10b981' }}>{t('permissions.admin')}</div>
                            ) : (
                                <div
                                    onClick={() => onTogglePerm(u.id)}
                                    style={{
                                        width: '32px', height: '16px', borderRadius: 'var(--radius-lg)',
                                        background: isAct ? '#10b981' : '#444', position: 'relative', cursor: 'pointer', transition: 'background 0.2s'
                                    }}
                                >
                                    <div style={{
                                        position: 'absolute', top: '2px', left: isAct ? '18px' : '2px',
                                        width: '12px', height: '12px', background: '#fff', borderRadius: '50%', transition: 'left 0.2s'
                                    }}/>
                                </div>
                            )}
                        </div>
                    )
                })}
             </div>
         </div>
      )}
    </div>
  );
}
